/**
 * Class for holding the data of a product
 */
export class Product {
    /**
     * internal id of the product
     */
    id: number;

    /**
     * internal ID of a product
     */
    internal_id: string;

    /**
     * name of the products
     */
    name: string;

    /**
     * plural version of the name
     */
    name_plural: string;

    /**
     * toggle if the price can be zero
     */
    has_zero_price: boolean;

    /**
     * toggle if the number selection is visible for free price products
     */
    has_force_count: boolean;

    /**
     * toggle for the textinput on a product
     */
    has_textinput: boolean

    /**
     * singel price of the product
     */
    price: any;

    /**
     * categories in which the product should be visible
     */
    categories: number[] = [];

    /**
     * one or more images for the details view of a product
     */
    images: {id: number, file: string, forgift: boolean}[];

    /**
     * description of the product
     */
    description: string;

    /** 
     * text for the details page.
     */
    text: string;

    /**
     * maximum number of products in stock
     */
    max_count: number;

    /**
     * maximum number of products allowed in cart
     */
    max_count_cart: number;

    /**
     * number of products already purchased
     */
    count: number = null;

    /**
     * digital download url for the product
     */
    file: string = null;

    /**
     * product is purchasable
     */
    isPurchasable: boolean = false;

    /**
     * type of the product
     */
    type: 'product' | 'bundle';

    /**
     * products in a bundle
     */
    bundle_products: {product_id: number, count: number, product?: Product}[];

    /**
     * The maximum number of purchasable items
     */
    getMaxCount(): number {
        // minSafe filters out NaN and null values, so this will work even if max_count_cart is not available yet
        const minSafe = (...args) => Math.min(...args.filter(val => val != null && !isNaN(val)));

        // total products minus already sold products
        const productsInStock = this.max_count > 0 && this.count !== null ? this.max_count - this.count : null;

        // use the lower value of max_count_cart and productsInStock
        const maxCount = minSafe(productsInStock, this.max_count_cart);

        return maxCount > 0 ? maxCount : -1;
    }

    /**
     * check if the product is available for purchase
     */
    checkIfPurchasable() {
        // Check if the product has both 'max_count' and 'count' properties
        const hasMaxCountAndCount = this.hasOwnProperty("max_count") && this.hasOwnProperty("count");

        // Check if both 'max_count' and 'count' are not null
        const maxCountAndCountNotNull = this.max_count !== null && this.count !== null;

        // Check if the product's count is greater than or equal to the product's max_count
        const countLessThanMaxCount = this.count >= this.max_count;

        // product is not available for purchase
        this.isPurchasable = !(hasMaxCountAndCount && maxCountAndCountNotNull && countLessThanMaxCount);   

        return this.isPurchasable;
    }

    /**
     * Copies dta from an anonymous object into the current donation object.
     * @param data
     */
    public copyData(data) {
        for (const key in data) {
            if (this.hasOwnProperty(key)) {
                if (typeof this[key] === "object" && this[key] !== null) {
                    if (data[key]) {
                        this[key] = Object.assign(this[key], data[key]);
                    }
                }
                else {
                    this[key] = data[key];
                }
            }
        }
    }
}
